import styled from 'styled-components';

export const Wave = styled.div`
    position: 'absolute',
    top: '15%',
    right: '45%',
    z-index: 5,
    overflow: hidden,
    display: block,
`;